// extracted by css-extract-rspack-plugin
export default {"suggestFormWrapper":"suggest-form-wrapper--xwkTlh6gnoiPGqQc","suggestForm":"suggest-form--KjO2Ccah3R06udmu"};